var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-main" },
        [
          _c("h3", [_vm._v("Send Message")]),
          _vm._v(" "),
          !_vm.pagesWithPrimaryOrSecondaryParentOption.includes(
            this.$route.path
          )
            ? _c("div", { staticClass: "checkbox" }, [
                _c("p", { staticClass: "checkbox__select-label" }, [
                  _vm._v("Select who will receive the email")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkbox__input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entitySelected,
                        expression: "entitySelected"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "primary",
                      value: "primary"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.entitySelected)
                        ? _vm._i(_vm.entitySelected, "primary") > -1
                        : _vm.entitySelected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.entitySelected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "primary",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.entitySelected = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.entitySelected = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.entitySelected = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "primary" } }, [
                    _vm._v(
                      "\n                        Primary Contact\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entitySelected,
                        expression: "entitySelected"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      id: "secondary",
                      value: "secondary"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.entitySelected)
                        ? _vm._i(_vm.entitySelected, "secondary") > -1
                        : _vm.entitySelected
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.entitySelected,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "secondary",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.entitySelected = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.entitySelected = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.entitySelected = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "secondary" } }, [
                    _vm._v(
                      "\n                        Secondary Contact\n                    "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.pagesWithCopyNote.includes(this.$route.path)
            ? _c("p", { staticClass: "checkbox__select-label copy__email" }, [
                _vm._v(
                  "\n                CC: " +
                    _vm._s(_vm.userInfo.email) +
                    "\n            "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("app-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|min:1|max:100",
                expression: "'required|min:1|max:100'"
              }
            ],
            attrs: {
              id: "subject",
              label: "Subject",
              name: "subject",
              type: "text"
            },
            model: {
              value: _vm.form.subject,
              callback: function($$v) {
                _vm.$set(_vm.form, "subject", $$v)
              },
              expression: "form.subject"
            }
          }),
          _vm._v(" "),
          _c("text-editor", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:8000",
                expression: "'required|max:8000'"
              }
            ],
            attrs: { name: "editor", height: _vm.height },
            on: {
              input: function($event) {
                _vm.form.message = $event
              }
            },
            model: {
              value: _vm.form.message,
              callback: function($$v) {
                _vm.$set(_vm.form, "message", $$v)
              },
              expression: "form.message"
            }
          }),
          _vm._v(" "),
          !_vm.pagesWithAttachmentOption.includes(this.$route.path)
            ? _c(
                "div",
                { staticClass: "input-container" },
                [
                  _c(
                    "div",
                    { staticClass: "file-input__container" },
                    _vm._l(this.attachment, function(file) {
                      return _c(
                        "div",
                        { key: file.name, staticClass: "file-item" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(file.name) +
                              "\n                        "
                          ),
                          _c("div", { staticClass: "file-item__remove" }, [
                            _c("img", {
                              staticClass: "file-item__remove-img",
                              attrs: {
                                src: require("../../assets/img/close.svg")
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.removeFileFromList(file)
                                }
                              }
                            })
                          ])
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("email-file-input", {
                    ref: "fileInput",
                    staticStyle: { "margin-top": "-20px" },
                    attrs: {
                      id: "file",
                      name: "attachment",
                      text: "" + this.fileInputText,
                      "btn-text": "Choose file",
                      "hide-error": true
                    },
                    on: {
                      change: function($event) {
                        return _vm.handleFilesUpload($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.showFileSizeError
                    ? _c(
                        "div",
                        {
                          staticClass: "error",
                          staticStyle: { "margin-top": "-20px" }
                        },
                        [_vm._v("Total file size should be less than 20Mb")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.fields.editor &&
                    (_vm.fields.editor.touched || _vm.fields.editor.validated),
                  expression:
                    "fields.editor && (fields.editor.touched ||\n                        fields.editor.validated)"
                }
              ],
              staticClass: "error"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.errors.first("editor")) +
                  "\n            "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "primary-btn btn-center",
            attrs: {
              type: "submit",
              disabled:
                !_vm.formValid ||
                _vm.formPristine ||
                _vm.isBothCheckboxEmpty ||
                !_vm.isFileValid
            }
          },
          [_vm._v("Send\n            ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27306722", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27306722","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SendEmailModal.vue
// module id = null
// module chunks = 